import * as yup from "yup";

export const getAddReportCategorySchema = (reportCategories) => {
  return yup.object().shape({
    categories: yup
      .array()
      .of(
        yup.object().shape({
          name: yup
            .string()
            .label("Report Category")
            .strict()
            .trim(
              "No leading, ending, or empty spaces are permitted. Please check.",
            )
            .required()
            .test(
              "is-already-exist",
              "Report Category already created!",
              (text) =>
                reportCategories.filter(
                  (record) => record.toLowerCase() === text?.toLowerCase(),
                ).length === 0,
            )
            .test(
              "is-duplicate",
              () => {
                return `Report Category already exists`;
              },
              (text, testContext) => {
                return (
                  testContext.from[1].value.categories.filter(
                    (el, index) =>
                      index !== testContext.options.index &&
                      el.name?.toLowerCase() === text?.toLowerCase(),
                  ).length === 0
                );
              },
            ),
        }),
      )
      .required(),
  });
};

export default {
  getAddReportCategorySchema,
};
